// ** Redux Imports
import { get, post } from "../../../../common/api";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// ** Axios Imports
import axios from "axios";
import {
  LOGIN,
  APIPREFIX,
  LOGIN_SEND_OTP,
  VERIFY_LOGIN_OTP,
  REGISTRATION_FORM,
  FORGOT_PASSWORD,
  NEW_PASSWORD,
  VERIFY_TOKEN,
  LOGIN_OTP,
  VERIFY_REG_OTP,
  EMPLOYER_LOGIN,
  ADMIN_LOGIN,
  ZONE_LIST,
  FORGOT_PASSWORD_EMPLOYER_SEND_OTP,
  FORGOT_PASSWORD_ADMIN_SEND_OTP,
  FORGOT_PASSWORD_EMPLOYER_VERIFY_OTP,
  FORGOT_PASSWORD_ADMIN_VERIFY_OTP,
  LOGOUT_ADMIN,
  LOGOUT_EMPLOYER,
  LOGOUT_EMPLOYEE

} from "../../../../common/constant";

// export const actionLogin = createAsyncThunk('publicStore/actionLogin', async (params, thunkAPI) => {
//     const response = await axios.post(LOGIN, params)
//     return response.data
// })

export const actionLogin = createAsyncThunk(
  "publicStore/actionLogin",
  async (params, thunkAPI) => {
    const response = await axios.post(LOGIN, params);
    return response.data;
  }
);

export const actionLoginSendOtp = createAsyncThunk(
  "publicStore/actionLoginSendOtp",
  async (params, thunkAPI) => {
    try {
      // const response = await axios.post(OTP, params)
      const response = await axios.post(LOGIN_SEND_OTP, params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionLoginVerifyOtp = createAsyncThunk(
  "publicStore/actionLoginVerifyOtp",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(VERIFY_LOGIN_OTP, params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionRegistrationForm = createAsyncThunk(
  "publicStore/actionRegistrationForm",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(REGISTRATION_FORM, params);
      return response.data;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionVerifyRegOtp = createAsyncThunk(
  "publicStore/actionVerifyRegOtp",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(VERIFY_REG_OTP, params);
      return response.data;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Employer Login 
export const actionEmployerLogin = createAsyncThunk(
  "publicStore/actionEmployerLogin",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(EMPLOYER_LOGIN, params);
      return response.data
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Admin Login 
export const actionAdminLogin = createAsyncThunk(
  "publicStore/actionAdminLogin",
  async (params, thunkAPI) => {
    try {
      const response = await axios.post(ADMIN_LOGIN, params);
      return response.data
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);


// Admin Logout
export const actionAdminLogout = createAsyncThunk(
  "publicStore/actionAdminLogout",
  async (params, thunkAPI) => {
    try {
      const response = await post(LOGOUT_ADMIN, params, thunkAPI);
      return response;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Employer Logout
export const actionEmployerLogout = createAsyncThunk(
  "publicStore/actionEmployerLogout",
  async (params, thunkAPI) => {
    try {
      const response = await post(LOGOUT_EMPLOYER, params, thunkAPI);
      return response;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Employee Logout
export const actionEmployeeLogout = createAsyncThunk(
  "publicStore/actionEmployeeLogout",
  async (params, thunkAPI) => {
    try {
      const response = await post(LOGOUT_EMPLOYEE, params, thunkAPI);
      return response;
    }
    catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionForgotPassword = createAsyncThunk(
  "publicStore/actionForgotPassword",
  async (params) => {
    const response = await axios.post(FORGOT_PASSWORD, params);
    return response.data;
  }
);

export const actionNewPassword = createAsyncThunk(
  "publicStore/actionNewPassword",
  async (params) => {
    const response = await axios.post(NEW_PASSWORD, params);
    return response.data;
  }
);

export const actionVerifyToken = createAsyncThunk(
  "publicStore/actionVerifyToken",
  async (params) => {
    const response = await axios.post(VERIFY_TOKEN, params);
    return response.data;
  }
);

// zone list
export const actionZoneList = createAsyncThunk(
  "publicStore/actionZoneList",
  async (params, thunkAPI) => {
    const response = await axios.get(ZONE_LIST, params)
    return response.data;
  }
)


// FORGOT PASSWORD EMPLOYER SEND OTP
export const actionForgotPasswordEmployerSendOtp = createAsyncThunk(
  "publicStore/actionForgotPasswordEmployerSendOtp",
  async (params, thunkAPI) => {
    const response = await post(FORGOT_PASSWORD_EMPLOYER_SEND_OTP, params);
    return response.data;
  }
);

// FORGOT PASSWORD ADMIN SEND OTP
export const actionForgotPasswordAdminSendOtp = createAsyncThunk(
  "publicStore/actionForgotPasswordAdminSendOtp",
  async (params, thunkAPI) => {
    const response = await axios.post(FORGOT_PASSWORD_ADMIN_SEND_OTP, params);
    return response.data;
  }
);

// FORGOT PASSWORD EMPLOYER SEND OTP
export const actionForgotPasswordEmployerVerifyOtp = createAsyncThunk(
  "publicStore/actionForgotPasswordEmployerVerifyOtp",
  async (params, thunkAPI) => {
    const response = await axios.post(FORGOT_PASSWORD_EMPLOYER_VERIFY_OTP, params);
    return response.data;
  }
);

// FORGOT PASSWORD ADMIN SEND OTP
export const actionForgotPasswordAdminVerifyOtp = createAsyncThunk(
  "publicStore/actionForgotPasswordAdminVerifyOtp",
  async (params, thunkAPI) => {
    const response = await axios.post(FORGOT_PASSWORD_ADMIN_VERIFY_OTP, params);
    return response.data;
  }
);

export const appPublicSlice = createSlice({
  name: "publicStore",
  initialState: {
    //add
    loadingLogin: false,
    login: null,

    // Login otp
    loadingLoginOtp: false,
    getLoginOtp: null,

    // Verify Login otp
    loadingVerifyLoginOtp: false,
    getVerifyLoginOtp: null,
    getVerifyLoginOtpError: null,

    // Registration 
    loadingRegistrationForm: false,
    registrationForm: null,

    // Verify Registration OTP
    loadingVerifyRegOtp: false,
    getVerifyRegOtp: null,

    // Employer Login
    loadingEmployerLogin: false,
    EmployerLogin: null,

    // Admin Login
    loadingAdminLogin: false,
    AdminLogin: null,

    //Admin logout
    loadingAdminLogout: false,
    AdminLogout: null,

    //Employer logout
    loadingEmployerLogout: false,
    EmployerLogout: null,

    //Employee logout
    loadingEmployeeLogout: false, 
    EmployeeLogout: null,

    //forgot password
    loadingForgotPass: false,
    forgotPassword: null,

    //new password
    loadingNewPassword: false,
    newPassword: null,

    //verify password
    loadingVerifyPassword: false,
    verifyToken: null,

    // 
    loadingZoneList: false,
    zoneList: null,

    //forgot password employer SEND OTP
    loadingForgotPassEmployerSendOtp: false,
    forgotPasswordEmployerSendOtp: null,

    //forgot password employer SEND OTP
    loadingForgotPassAdminSendOtp: false,
    forgotPasswordAdminSendOtp: null,

    //forgot password employer VERIFY OTP
    loadingForgotPassEmployerVerifyOtp: false,
    forgotPasswordEmployerVerifyOtp: null,

    //forgot password employer VERIFY OTP
    loadingForgotPassAdminVerifyOtp: false,
    forgotPasswordAdminVerifyOtp: null,

  },
  reducers: {
    //reset or delete Add Insurance Company store data
    resetLoginResponse: (state) => {
      state.login = null;
    },
    resetLoginOtpResponse: (state) => {
      state.getLoginOtp = null;
    },
    resetVerifyLoginOtpResponse: (state) => {
      state.getVerifyLoginOtp = null;
    },
    resetRegistrationFormResponse: (state) => {
      state.registrationForm = null;
    },
    resetVerifyRegOtpResponse: (state) => {
      state.getVerifyRegOtp = null;
    },
    resetEmployerLoginResponse: (state) => {
      state.EmployerLogin = null;
    },
    resetAdminLoginResponse: (state) => {
      state.AdminLogin = null;
    },

     resetAdminLogoutResponse: (state) => {
      state.AdminLogout = null;
    },

     resetEmployerLogoutResponse: (state) => { 
      state.EmployerLogout = null;
    },

      resetEmployeeLogoutResponse: (state) => {
      state.EmployeeLogout = null;
      },

    
    
    resetForgotPasswordResponse: (state) => {
      state.forgotPassword = null;
    },
    resetNewPasswordResponse: (state) => {
      state.newPassword = null;
    },
    resetVerifyTokendResponse: (state) => {
      state.verifyToken = null;
    },
    resetZoneListResponse: (state) => {
      state.zoneList = null;
    },
    // Forgot Password Employer SEND OTP
    resetForgotPasswordEmployerSendOtpResponse: (state) => {
      state.forgotPasswordEmployerSendOtp = null;
    },
    // Forgot Password Admin SEND OTP
    resetForgotPasswordAdminSendOtpResponse: (state) => {
      state.forgotPasswordAdminSendOtp = null;
    },

    // Forgot Password Employer VERIFY OTP
    resetForgotPasswordEmployerVerifyOtpResponse: (state) => {
      state.forgotPasswordEmployerVerifyOtp = null;
    },
    // Forgot Password Admin VERIFY OTP
    resetForgotPasswordAdminVerifyOtpResponse: (state) => {
      state.forgotPasswordAdminVerifyOtp = null;
    },
  },
  extraReducers: (builder) => {
    builder
      //add
      .addCase(actionLogin.pending, (state) => {
        state.loadingLogin = true;
      })
      .addCase(actionLogin.fulfilled, (state, action) => {
        state.loadingLogin = false;
        state.login = action.payload;
      })
      .addCase(actionLogin.rejected, (state) => {
        state.loadingLogin = false;
      })

      // otp
      .addCase(actionLoginSendOtp.pending, (state) => {
        state.loadingLoginOtp = true;
      })
      .addCase(actionLoginSendOtp.fulfilled, (state, action) => {
        state.loadingLoginOtp = false;
        state.getLoginOtp = action.payload;
      })
      .addCase(actionLoginSendOtp.rejected, (state, action) => {
        state.loadingLoginOtp = false;
        state.getLoginOtp = { status: false, message: action.payload };
      })

      // verify otp
      .addCase(actionLoginVerifyOtp.pending, (state) => {
        state.loadingVerifyLoginOtp = true;
      })
      .addCase(actionLoginVerifyOtp.fulfilled, (state, action) => {
        state.loadingVerifyLoginOtp = false;
        state.getVerifyLoginOtp = action.payload;
      })
      .addCase(actionLoginVerifyOtp.rejected, (state, action) => {
        state.loadingVerifyLoginOtp = false;
        // assign error to getVerifyLoginOtp
        state.getVerifyLoginOtp = { status: false, message: action.payload };
      })

      // Registration Form
      .addCase(actionRegistrationForm.pending, (state) => {
        state.loadingRegistrationForm = true;
      })
      .addCase(actionRegistrationForm.fulfilled, (state, action) => {
        state.loadingRegistrationForm = false;
        state.registrationForm = action.payload;
      })
      .addCase(actionRegistrationForm.rejected, (state, action) => {
        state.loadingRegistrationForm = false;
        state.registrationForm = { status: false, message: action.payload };
      })

      // employer Login
      .addCase(actionEmployerLogin.pending, (state) => {
        state.loadingEmployerLogin = true;
      })
      .addCase(actionEmployerLogin.fulfilled, (state, action) => {
        state.loadingEmployerLogin = false;
        state.EmployerLogin = action.payload;
      })
      .addCase(actionEmployerLogin.rejected, (state, action) => {
        state.loadingEmployerLogin = false;
        state.EmployerLogin = { status: false, message: action.payload };
      })

      // Admin Login
      .addCase(actionAdminLogin.pending, (state) => {
        state.loadingAdminLogin = true;
      })
      .addCase(actionAdminLogin.fulfilled, (state, action) => {
        state.loadingAdminLogin = false;
        state.AdminLogin = action.payload;
      })
      .addCase(actionAdminLogin.rejected, (state, action) => {
        state.loadingAdminLogin = false;
        state.AdminLogin = { status: false, message: action.payload };
      })

      // Admin Logout
      .addCase(actionAdminLogout.pending, (state) => {
        state.loadingAdminLogout = true;
      })  
      .addCase(actionAdminLogout.fulfilled, (state, action) => {
        state.loadingAdminLogout = false;
        state.AdminLogout = action.payload;
      })
      .addCase(actionAdminLogout.rejected, (state, action) => {
        state.loadingAdminLogout = false;
        state.AdminLogout = { status: false, message: action.payload };
      })

      // Employer Logout  
      .addCase(actionEmployerLogout.pending, (state) => {
        state.loadingEmployerLogout = true;
      })
      .addCase(actionEmployerLogout.fulfilled, (state, action) => {
        state.loadingEmployerLogout = false;
        state.EmployerLogout = action.payload;
      })
      .addCase(actionEmployerLogout.rejected, (state, action) => {
        state.loadingEmployerLogout = false;
        state.EmployerLogout = { status: false, message: action.payload };
      })

      // Employee Logout
      .addCase(actionEmployeeLogout.pending, (state) => {
        state.loadingEmployeeLogout = true;
      })
      .addCase(actionEmployeeLogout.fulfilled, (state, action) => {
        state.loadingEmployeeLogout = false;      
        state.EmployeeLogout = action.payload;
      })

      .addCase(actionEmployeeLogout.rejected, (state, action) => {
        state.loadingEmployeeLogout = false;    
        state.EmployeeLogout = { status: false, message: action.payload };
      })


      // Registration otp mobile and email
      .addCase(actionVerifyRegOtp.pending, (state) => {
        state.loadingVerifyRegOtp = true;
      })
      .addCase(actionVerifyRegOtp.fulfilled, (state, action) => {
        state.loadingVerifyRegOtp = false;
        state.getVerifyRegOtp = action.payload;
      })
      .addCase(actionVerifyRegOtp.rejected, (state, action) => {
        state.loadingVerifyRegOtp = false;
        state.getVerifyRegOtp = { status: false, message: action.payload };
      })

      //forgot password
      .addCase(actionForgotPassword.pending, (state) => {
        state.loadingForgotPass = true;
      })
      .addCase(actionForgotPassword.fulfilled, (state, action) => {
        state.loadingForgotPass = false;
        state.forgotPassword = action.payload;
      })
      .addCase(actionForgotPassword.rejected, (state) => {
        state.loadingForgotPass = false;
      })

      //new password
      .addCase(actionNewPassword.pending, (state) => {
        state.loadingNewPassword = true;
      })
      .addCase(actionNewPassword.fulfilled, (state, action) => {
        state.loadingNewPassword = false;
        state.newPassword = action.payload;
      })
      .addCase(actionNewPassword.rejected, (state) => {
        state.loadingNewPassword = false;
      })

      //verify password
      .addCase(actionVerifyToken.pending, (state) => {
        state.loadingVerifyPassword = true;
      })
      .addCase(actionVerifyToken.fulfilled, (state, action) => {
        state.loadingVerifyPassword = false;
        state.verifyToken = action.payload;
      })
      .addCase(actionVerifyToken.rejected, (state) => {
        state.loadingVerifyPassword = false;
      })

      // zone list
      .addCase(actionZoneList.pending, (state) => {
        state.loadingZoneList = true;
      })

      .addCase(actionZoneList.fulfilled, (state, action) => {
        state.loadingZoneList = false;
        state.zoneList = action.payload
      })

      .addCase(actionZoneList.rejected, (state) => {
        state.loadingZoneList = false;
      })

      //forgot password Employer SEND OTP
      .addCase(actionForgotPasswordEmployerSendOtp.pending, (state) => {
        state.loadingForgotPassEmployerSendOtp = true;
      })
      .addCase(actionForgotPasswordEmployerSendOtp.fulfilled, (state, action) => {
        state.loadingForgotPassEmployerSendOtp = false;
        state.forgotPasswordEmployerSendOtp = action.payload;
      })
      .addCase(actionForgotPasswordEmployerSendOtp.rejected, (state) => {
        state.loadingForgotPassEmployerSendOtp = false;
      })

      //forgot password Admin SEND OTP
      .addCase(actionForgotPasswordAdminSendOtp.pending, (state) => {
        state.loadingForgotPassAdminSendOtp = true;
      })
      .addCase(actionForgotPasswordAdminSendOtp.fulfilled, (state, action) => {
        state.loadingForgotPassAdminSendOtp = false;
        state.forgotPasswordAdminSendOtp = action.payload;
      })
      .addCase(actionForgotPasswordAdminSendOtp.rejected, (state) => {
        state.loadingForgotPassAdminSendOtp = false;
      })

      //forgot password Employer VERIFY OTP
      .addCase(actionForgotPasswordEmployerVerifyOtp.pending, (state) => {
        state.loadingForgotPassEmployerVerifyOtp = true;
      })
      .addCase(actionForgotPasswordEmployerVerifyOtp.fulfilled, (state, action) => {
        state.loadingForgotPassEmployerVerifyOtp = false;
        state.forgotPasswordEmployerVerifyOtp = action.payload;
      })
      .addCase(actionForgotPasswordEmployerVerifyOtp.rejected, (state) => {
        state.loadingForgotPassEmployerVerifyOtp = false;
      })

      //forgot password Admin VERIFY OTP
      .addCase(actionForgotPasswordAdminVerifyOtp.pending, (state) => {
        state.loadingForgotPassAdminVerifyOtp = true;
      })
      .addCase(actionForgotPasswordAdminVerifyOtp.fulfilled, (state, action) => {
        state.loadingForgotPassAdminVerifyOtp = false;
        state.forgotPasswordAdminVerifyOtp = action.payload;
      })
      .addCase(actionForgotPasswordAdminVerifyOtp.rejected, (state) => {
        state.loadingForgotPassAdminVerifyOtp = false;
      })

  },
});

export const {
  resetLoginResponse,
  resetLoginOtpResponse,
  resetVerifyLoginOtpResponse,
  resetRegistrationFormResponse,
  resetForgotPasswordResponse,
  resetNewPasswordResponse,
  resetVerifyTokendResponse,
  resetVerifyRegOtpResponse,
  resetEmployerLoginResponse,
  resetAdminLoginResponse,
  resetAdminLogoutResponse,
  resetEmployerLogoutResponse,
  resetEmployeeLogoutResponse,
  resetZoneListResponse,
  resetForgotPasswordEmployerSendOtpResponse,
  resetForgotPasswordAdminSendOtpResponse,
  resetForgotPasswordEmployerVerifyOtpResponse,
  resetForgotPasswordAdminVerifyOtpResponse,
} = appPublicSlice.actions;

function parseErrorv1(error) {
  return error?.response?.data?.message;
}

export default appPublicSlice.reducer;
